import axios, { AxiosError } from 'axios';

axios.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        if (error.response?.status === 401) {
            window.location.href = `${window.location.pathname}?gcp-iap-mode=FORCE_LOGIN`;
            return new Promise(() => {});
        }
        return Promise.reject(error);
    }
);
